export default (props) => (
    <dl className="tooltip top">
      <dd
        aria-describedby="text"
        tabIndex="0"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "40px", // adjust as needed
          width: "40px", // optional, for a square area
        }}
      >
        <div>
          <span
            className={`icon ${props.className || ""} small`}
            style={{
              display: "inline-block",
              width: "20px", // or match your icon's actual size
              height: "20px",
              WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`,
              maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`,
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              maskPosition: "center",
              backgroundColor: `${props.color || "var(--color-theme-variant)"}`,
            }}
          ></span>
        </div>
      </dd>
      <dt role="tooltip" id="text" hidden={true}>
        {props.text}
      </dt>
    </dl>
  );
  